import { Navigate } from 'react-router-dom';
import WatchDetails from '../pages/watchDetails';
import WatchInput from '../pages/watchInput';

const ProtectedRoute = ({ children }) => {
  const watchNo = localStorage.getItem('invicta-watch-no');
  return watchNo ? children : <Navigate to="/" replace />;
};

// const PublicRoute = ({ children }) => {
//   const watchNo = localStorage.getItem('invicta-watch-no');
//   return watchNo ? <Navigate to="/watch-details" replace /> : children;
// };

const PublicRoute = ({ children }) => {
  return children;
};

const routes = [
  {
    path: '/',
    element: (
      <PublicRoute>
        <WatchInput />
      </PublicRoute>
    ),
  },
  {
    path: '/watch-details/:watchNo',
    element: (
      <PublicRoute>
        <WatchDetails />
      </PublicRoute>
    ),
  },
];

export { routes };
